// extracted by mini-css-extract-plugin
export default {"tableMainContainer":"CommanTable_tableMainContainer__CzjwS","table":"CommanTable_table__nzcOW","pagination":"CommanTable_pagination__RpF7l"};